import { render } from "./SuggestionsComp.vue?vue&type=template&id=2c0a5030&scoped=true"
import script from "./SuggestionsComp.vue?vue&type=script&lang=js"
export * from "./SuggestionsComp.vue?vue&type=script&lang=js"

import "./SuggestionsComp.vue?vue&type=style&index=0&id=2c0a5030&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c0a5030"]])

export default __exports__